module.exports = __webpack_public_path__ + "img/IMG_6558_Mockup.5007df5e.jpg";